document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-offer]').forEach(root=>{const cards=[...root.querySelectorAll('[data-bundle]')],hidden=root.querySelector('[data-cart-qty]'),input=root.querySelector('[data-visible-qty]'),form=root.querySelector('form'),button=root.querySelector('[data-submit]');let pack=1;cards.forEach(card=>card.addEventListener('click',()=>{cards.forEach(x=>x.classList.remove('selected'));card.classList.add('selected');card.querySelector('input').checked=true;pack=Number(card.dataset.bundle)}));root.querySelectorAll('[data-change]').forEach(btn=>btn.addEventListener('click',()=>input.value=Math.max(1,Math.min(99,Number(input.value||1)+Number(btn.dataset.change)))));form?.addEventListener('submit',()=>{hidden.value=pack*Math.max(1,Number(input.value||1));button.disabled=true;button.textContent='ADDING…'})})});

(function(){
  function money(cents,currency){
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format(cents/100)}
    catch(error){return '$'+(cents/100).toFixed(2)}
  }
  function updatePackage(card,nextQuantity){
    if(!card)return;
    var input=card.querySelector('input[name="quantity"]');
    if(!input)return;
    var quantity=Math.max(1,Math.min(99,Number(nextQuantity===undefined?input.value:nextQuantity)||1));
    input.value=quantity;
    var display=card.querySelector('[data-quantity-display]');
    if(display)display.textContent=quantity;
    var total=card.querySelector('.p8-total b');
    var unitPrice=Number(card.dataset.unitPrice||0);
    if(!(unitPrice>0)){
      var manual=String(card.dataset.manualPrice||'').replace(/,/g,'').match(/[0-9]+(?:\.[0-9]+)?/);
      if(manual)unitPrice=Math.round(Number(manual[0])*100);
    }
    if(total&&unitPrice>0)total.textContent=money(unitPrice*quantity,card.dataset.currency);
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-p8-package] [data-plus], [data-p8-package] [data-minus]');
    if(!button)return;
    event.preventDefault();
    var card=button.closest('[data-p8-package]');
    var input=card&&card.querySelector('input[name="quantity"]');
    if(!input)return;
    updatePackage(card,Number(input.value||1)+(button.hasAttribute('data-plus')?1:-1));
  });
})();
